/**
 * Order Status Directive
 * @param element
 * @param binding
 * @param vNode
 */
import { $vm } from "@/components";

const OrderStatus = (element, binding, vNode) => {
  const { value } = binding;

  // Create new div for status text
  const item = document.createElement("div");
  item.classList.add("status-tag-text");
  item.innerText = $vm.$t(value.toLowerCase());
  element.classList.value = `source-tag ${value.toLowerCase()}`;
  // element.classList.add(value.toLowerCase());
  element.innerHTML = "";
  element.appendChild(item);
};

// Order Status Label
export default OrderStatus;
